import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { grey1, grey4 } from 'approot/shared/styles/colours.style';
import { SecondaryButtonIcon } from 'approot/shared/styles/buttons/buttons';
import { borderRadius8 } from 'approot/shared/styles/borders.style';
import { spacing4, spacing8 } from 'approot/shared/styles/spacing.style';

export const SettingComponentMenuWrapper = styled.div`
  position: relative;
  z-index: 100;
`;

type SettingsComponentMenuProps = {
  $hide?: boolean;
};
export const SettingsComponentMenu = styled.div<SettingsComponentMenuProps>`
  display: flex;
  max-width: calc(100vw - 260px);
  overflow-x: auto;
  padding: ${rem(spacing8)};
  position: absolute;

  ${({ $hide }) =>
    $hide &&
    `
    display: none;
  `}
`;

export const SettingsComponentMenuButton = styled(SecondaryButtonIcon).attrs({
  $noBorder: true,
  $isSmall: true,
})`
  background-color: transparent;
  height: ${rem(32)};
  margin: 0 ${rem(2)};
  min-width: ${rem(32)};
  width: ${rem(32)};
`;

export const SettingsComponentMenuInner = styled.div`
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.14);
  background-color: ${grey1};
  border: 1px solid ${grey4};
  border-radius: ${rem(borderRadius8)};
  display: flex;
  padding: ${rem(spacing4)} ${rem(2)};
  position: relative;
`;

export const SettingsComponentMenuHr = styled.div`
  background-color: ${grey4};
  height: 100%;
  margin: 0 ${rem(1)};
  min-width: ${rem(1)};
`;
